module.exports = "<hr />\n<h2>Latest offers</h2>\n<hr />\n\n<table class=\"list\">\n  <tr class=\"list\"><th>Offer</th> <th>For</th> <th>USD/1 coin</th> </tr>\n    <tr *ngFor=\"let offer of offers | async\" class=\"list\">\n        <td>{{offer.amountOffered | number:'0.2-5'}} {{offer.currencyOffered}}</td>\n        <td>{{offer.amountRequired | number:'0.2-5'}} {{offer.currencyRequired}}</td>\n        <td>{{offer.oneOfferedCoinInUsd | number:'0.5'}}</td>\n    </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/latest-offers/latest-offers.component.html
// module id = ./src/app/latest-offers/latest-offers.component.html
// module chunks = main